const preparePoint = (point: string): number[] =>
  point.split(',').map(a => parseFloat(a));

export default preparePoint;
